import { Directive, type Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { FormsKpAppStateService } from '../services/forms-kp-app-state.service';

@Directive({ selector: '[appFormsAppContext]', standalone: true, providers: [FormsKpAppStateService] })
export class FormsAppContextDirective extends AppContextDirective {
  // Angular owns the state on this directive's node, so removing a KP section disposes its live
  // subscriptions. The native context directive creates an embedded injector without destroying it;
  // only the alias belongs there, not a second app-state instance with its own subscription lifetime.
  public static readonly providers: Provider[] = [
    { provide: BaseAppStateService, useExisting: FormsKpAppStateService },
  ];

  protected getProviders(): Provider[] {
    return FormsAppContextDirective.providers;
  }
}
